<template>
  <div>
    <!-- Enquiry form -->
    <Dialog
      v-if="!contactFormDialog && !customerFormDialog"
      :visible.sync="opportunityDialog1"
      :style="{ width: '800px', height: '800px', overflowY: 'auto' }"
      header="Enquiry Details"
      :modal="true"
      class="p-fluid"
    >
      <template #header>
        <h5>Enquiry Details</h5>

        <!-- v-on:click="changeStatus()"  -->
        <span :class="'ignore pointer badge ' + getStyle(opportunityStatus)">
          {{
            opportunityStatus && opportunityStatus.oppStatusName
              ? opportunityStatus.oppStatusName
              : ""
          }}
        </span>
        <!-- <OverlayPanel 
          ref="statuses" 
          appendTo="body" 
          :showCloseIcon="true" 
          id="statuses" 
          style="width: 120px"
        > 
          <div
            v-for="(val, index) in opportunityStatuses"
            :key="index"
          >
            <span 
              @click="updateStatus(val)" 
              :class="'ignore pointer badge ' + getStyle(val)" 
            >
              {{ val.oppStatusName }}
            </span>
            <br />
            <br />
          </div>
        </OverlayPanel> -->

        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </template>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="oppDescription">Description</label>
          <InputText
            @blur="checkForDuplicateEnquiry"
            id="oppDescription"
            v-model.trim="opportunity.oppDescription"
            required="false"
            :disabled="disabledArr.includes('Description')"
            :class="{
              'p-invalid': submitted && !opportunity.oppDescription
            }"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="submitted && !opportunity.oppDescription"
            >Description is required.</small
          >
        </div>
        <div
          v-if="opportunity.quoteNo || opportunity.quoteNo === null"
          class="p-field p-col-6"
        >
          <label for="quoteNo">Quote No</label>
          <InputText
            v-model="opportunity.quoteNo"
            placeholder="Quote No"
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address1">House</label>
          <InputText
            @blur="checkForDuplicateEnquiry"
            id="address1"
            v-model.trim="opportunity.address1"
            :disabled="disabledArr.includes('Address 1')"
            :class="{ 'p-invalid': submitted && !opportunity.address1 }"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="submitted && !opportunity.address1"
            >House is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address2">Street</label>
          <InputText
            @blur="checkForDuplicateEnquiry"
            id="address2"
            v-model.trim="opportunity.address2"
            required="false"
            :disabled="disabledArr.includes('Address 2')"
            :class="{ 'p-invalid': submitted && !opportunity.address2 }"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="submitted && !opportunity.address2"
            >Street is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address3">Sub Area</label>
          <InputText
            @blur="checkForDuplicateEnquiry"
            id="address3"
            v-model.trim="opportunity.address3"
            required="false"
            :disabled="disabledArr.includes('Address 3')"
            :class="{ 'p-invalid': submitted && !opportunity.address3 }"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="submitted && !opportunity.address3"
            >Area is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address4">City/Town</label>
          <CustomDropDown
            :key="reloadCustomDropdown"
            :allOptions="citiesTowns"
            :disabled="false"
            optionLabel="cityTownName"
            dataKey="id"
            :forceSelection="true"
            :showDropDownOnStart="true"
            :currentValue="cityTown"
            placeholder="Select City/Town"
            style="width: 100%"
            @selected="setSelection"
            :inputClass="{
              'p-invalid': submitted && !(cityTown && cityTown.id)
            }"
          />
          <small
            class="p-invalid"
            v-if="submitted && !(cityTown && cityTown.id)"
            >City/Town is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="postCode">Post Code</label>
          <InputText
            @blur="checkForDuplicateEnquiry"
            id="postCode"
            v-model.trim="opportunity.postCode"
            required="false"
            :disabled="disabledArr.includes('Post Code')"
            :class="{ 'p-invalid': submitted && !opportunity.postCode }"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="submitted && !opportunity.postCode"
            >Post Code is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="region">Region</label>
          <Dropdown
            id="region"
            v-model="region"
            :options="regions"
            optionLabel="regionName"
            dataKey="id"
            placeholder="Select Region"
            :showClear="true"
            :disabled="true"
          />
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col" v-if="duplicateCheckingEnquiry">
          <div class="errorMsg" style="background-color: dodgerblue;">
            <span class="errorSpan">
              Checking for duplicate enquiries...
            </span>
          </div>
        </div>
        <div
          class="p-field p-col"
          v-if="!duplicateCheckingEnquiry && duplicatEnquiries.length"
        >
          <div class="errorMsg">
            <span class="errorSpan pr-5">
              Possible duplicate enquiries: {{ duplicatEnquiries.length }}
            </span>
            <span
              class="errorSpan errorPointer pr-3"
              @click="displayEnquiryDuplicateMessage = true"
            >
              View duplicates
            </span>
            <span
              class="errorSpan errorPointer"
              @click="checkForDuplicateEnquiry()"
              v-if="
                lastOppDescription !== opportunity.oppDescription ||
                  lastAddress1 !== opportunity.address1 ||
                  lastAddress2 !== opportunity.address2 ||
                  lastAddress3 !== opportunity.address3 ||
                  lastCityTown !==
                    (opportunity.cityTown && opportunity.cityTown.id) ||
                  lastPostCode !== opportunity.postCode
              "
            >
              Check again
            </span>
          </div>
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="customer">Customer *</label>
          <div class="p-inputgroup">
            <InputText
              class="clearer"
              placeholder="Click button to search for customer"
              :disabled="true"
              v-model="customerName"
              :class="{ 'p-invalid': submitted && !opportunity.customer }"
            >
            </InputText>
            <Button
              icon="pi pi-search"
              class="p-button-warning"
              @click="() => (custSearchDialog = true)"
              :disabled="disabledArr.includes('Customer')"
              id="customer"
            />
          </div>
          <small class="p-invalid" v-if="submitted && !opportunity.customer"
            >Customer is required.</small
          >
        </div>
        <div class="p-field p-col" style="position: relative">
          <label for="contact">Contact *</label>
          <Dropdown
            v-model="contact"
            :showClear="true"
            :options="contacts"
            dataKey="contactId"
            optionLabel="contactName"
            placeholder="Select Contact"
            id="contact"
            :disabled="disabledArr.includes('Contact')"
            :class="{ 'p-invalid': submitted && !opportunity.contact }"
          />
          <small class="p-invalid" v-if="submitted && !opportunity.contact"
            >Contact is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col p-sm-6">
          <label for="branch">Branch</label>
          <Dropdown
            :key="mbpBranchKey"
            :showClear="false"
            v-model="mbpBranch"
            :options="branches"
            optionLabel="branchName"
            dataKey="branchId"
            placeholder="Select Branch"
            id="mbpBranch"
            :disabled="disabledArr.includes('mbpBranch') || onlyUserBranch"
            :class="{ 'p-invalid': submitted && !mbpBranch }"
          />
          <small class="p-invalid" v-if="submitted && !mbpBranch"
            >Branch is required.</small
          >
        </div>
        <div class="p-field p-col p-sm-6"></div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col p-sm-6">
          <label for="phoneNo">Phone No</label>
          <InputText
            id="phoneNo"
            v-model.trim="phoneNo"
            required="false"
            :disabled="disabledArr.includes('Phone No')"
            :class="{ 'p-invalid': submitted && !opportunity.phoneNo }"
          />
          <small class="p-invalid" v-if="submitted && !opportunity.phoneNo"
            >Phone Number is required.</small
          >
        </div>
        <div class="p-field p-col p-sm-6">
          <label for="email">Email</label>
          <InputText
            id="email"
            v-model.trim="opportunity.email"
            required="false"
            :disabled="disabledArr.includes('Email')"
            :class="{ 'p-invalid': submitted && !opportunity.email }"
          />
          <small class="p-invalid" v-if="submitted && !opportunity.email"
            >Email is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="salesExec">Sales Exec</label>
          <InputText
            id="salesExec"
            v-model.trim="salesExec1Name"
            required="false"
            disabled="true"
          />
        </div>
        <div class="p-field p-col">
          <label for="projectType">Enquiry Type *</label>
          <Dropdown
            :key="projectTypeKey"
            v-model="projectType"
            :showClear="true"
            :options="projectTypes"
            optionLabel="projTypeName"
            dataKey="id"
            placeholder="Select Enquiry Type"
            id="projectType"
            ref="projectType"
            :disabled="disabledArr.includes('Project Type')"
            :class="{ 'p-invalid': submitted && !opportunity.projectType }"
          />
          <small class="p-invalid" v-if="submitted && !opportunity.projectType"
            >Type is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="receivedDate">Date Received *</label>
          <Calendar
            id="receivedDate"
            v-model="opportunity.dateReceived"
            dateFormat="dd/mm/yy"
            :showTime="false"
            :disabled="disabledArr.includes('dateReceived')"
            :required="true"
            :class="{ 'p-invalid': submitted && !opportunity.dateReceived }"
          />
          <small class="p-invalid" v-if="submitted && !opportunity.dateReceived"
            >Date Received is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="requestedBy">Requested By (optional)</label>
          <InputText
            id="requestedBy"
            v-model.trim="opportunity.requestedBy"
            required="false"
            :disabled="disabledArr.includes('Requested By')"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="ABI">ABI No (optional)</label>
          <InputText
            id="abiNo"
            v-model.trim="opportunity.abiNo"
            required="false"
            :disabled="disabledArr.includes('ABI No')"
          />
        </div>
        <div class="p-field p-col">
          <label for="custRef">Customer Ref (optional)</label>
          <InputText
            id="custRef"
            v-model.trim="opportunity.custRef"
            required="false"
            :disabled="disabledArr.includes('Customer Ref')"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="notes">Notes (Optional)</label>
          <InputText
            id="notes"
            v-model.trim="opportunity.notes"
            required="false"
            :disabled="disabledArr.includes('Notes')"
          />
        </div>
      </div>

      <template #footer>
        <div class="p-grid" v-if="!disabledArr.includes('Buttons')">
          <div class="p-lg-4 p-md-3 p-sm-3"></div>
          <div class="p-lg-4 p-md-3 p-sm-3"></div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <Button
              label="Cancel"
              style="float: right; width: auto; width: 100px;"
              class="p-button-danger"
              icon="pi pi-times"
              @click="$emit('close')"
            />
          </div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <ProgressSpinner
              v-if="sendingRequest"
              style="float: right; width:25px; height:25px; width: 100px;"
              strokeWidth="5"
              fill="#EEEEEE"
              animationDuration=".5s"
            />
            <Button
              v-else
              label="Save"
              style="float: right; width: auto; width: 100px;"
              icon="pi pi-check"
              class="p-button-success"
              @click="save"
            />
          </div>
        </div>
      </template>
    </Dialog>

    <!-- Contact form -->
    <Dialog
      v-else-if="contactFormDialog && !customerFormDialog"
      :visible.sync="contactFormDialog"
      :style="{ width: '900px', overflowY: 'auto' }"
      header="Contact details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="firstName">First Name*</label>
          <InputText
            id="firstName"
            v-model.trim="contact.firstName"
            required="false"
            :class="{ 'p-invalid': contactSubmitted && !contact.firstName }"
            :disabled="disabledArr.includes('firstName')"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.firstName"
            >First Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="lastName">Surname*</label>
          <InputText
            id="lastName"
            v-model.trim="contact.lastName"
            required="false"
            :class="{ 'p-invalid': contactSubmitted && !contact.lastName }"
            :disabled="disabledArr.includes('lastName')"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.lastName"
            >Last Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="jobFunction">Job Function*</label>
          <Dropdown
            id="jobFunction"
            :showClear="true"
            v-model="contact.jobFunction"
            :options="jobFunctions"
            optionLabel="jobFuncName"
            placeholder="Select Job Function"
            :disabled="disabledArr.includes('jobFunction')"
            :class="{ 'p-invalid': contactSubmitted && !contact.jobFunction }"
          />
          <small
            class="p-invalid"
            v-if="contactSubmitted && !contact.jobFunction"
            >Job Function is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col p-col-8">
          <label for="jobTitle">Select Customer</label>
          <InputText
            id="customer"
            placeholder="Customer Name"
            :disabled="true"
            v-model="customer.custName"
          >
          </InputText>
        </div>
        <div class="p-field p-col p-col-4">
          <label for="jobTitle">Job Title</label>
          <InputText
            id="contactJobTitle"
            placeholder="Write a Job Title"
            :disabled="disabledArr.includes('contactJobTitle')"
            v-model="contact.contactJobTitle"
          >
          </InputText>
          <!-- <Dropdown
            v-model="contact.jobTitle"
            :options="jobTitles"
            optionLabel="jobTitleDesc"
            placeholder="Select Job Title"
            :showClear="true"
            id="jobTitle"
            :disabled="disabledArr.includes('jobTitle')"
            :class="{ 'p-invalid': contactSubmitted && !contact.jobTitle }"
          />
          <small
            class="p-invalid"
            v-if="contactSubmitted && !contact.jobTitle"
            >Job Title is required.</small
          > -->
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address1">House</label>
          <InputText
            id="address1"
            v-model.trim="contact.address1"
            required="false"
            :disabled="disabledArr.includes('address1')"
            :class="{ 'p-invalid': contactSubmitted && !contact.address1 }"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.address1"
            >House is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address2">Street</label>
          <InputText
            id="address2"
            v-model.trim="contact.address2"
            required="false"
            :disabled="disabledArr.includes('address2')"
            :class="{ 'p-invalid': contactSubmitted && !contact.address2 }"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.address2"
            >Street is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address3">Sub Area</label>
          <InputText
            id="address3"
            v-model.trim="contact.address3"
            required="false"
            :disabled="disabledArr.includes('address3')"
            :class="{ 'p-invalid': contactSubmitted && !contact.address3 }"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.address3"
            >Sub Area is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address4">City/Town</label>
          <CustomDropDown
            :allOptions="citiesTowns"
            :disabled="false"
            optionLabel="cityTownName"
            dataKey="id"
            :forceSelection="true"
            :showDropDownOnStart="true"
            :currentValue="cityTown2"
            placeholder="Select City/Town"
            style="width: 100%"
            @selected="setSelection2"
            :inputClass="{ 'p-invalid': contactSubmitted && !contact.cityTown }"
          />
        </div>
        <div class="p-field p-col">
          <label for="postCode">Post Code</label>
          <InputText
            id="postCode"
            v-model.trim="contact.postCode"
            required="false"
            autofocus
            :disabled="disabledArr.includes('postCode')"
            style="text-transform: uppercase;"
          />
        </div>
      </div>
      <!-- <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="country">Country</label>
          <InputText
            id="country"
            v-model.trim="contact.country"
            required="false"
            
            :disabled="disabledArr.includes('country')"
          />
        </div>
      </div> -->
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="phoneNo">Phone No</label>
          <InputText
            id="phoneNo"
            v-model.trim="contact.phoneNo"
            required="false"
            :disabled="disabledArr.includes('phoneNo')"
          />
        </div>
        <div class="p-field p-col">
          <label for="mobile">Mobile</label>
          <InputText
            id="mobile"
            v-model.trim="contact.mobile"
            required="false"
            :disabled="disabledArr.includes('mobile')"
          />
        </div>
        <div class="p-field p-col">
          <label for="email">Email</label>
          <InputText
            id="email"
            v-model.trim="contact.email"
            required="false"
            :disabled="disabledArr.includes('email')"
            :class="{ 'p-invalid': contactSubmitted && !contact.email }"
          />
          <small class="p-invalid" v-if="contactSubmitted && !contact.email"
            >Email is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="notes">Notes</label>
          <InputText
            id="notes"
            v-model.trim="contact.notes"
            :disabled="disabledArr.includes('notes')"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="canEmail">can Email?</label>
          <InputSwitch
            v-model="contact.canEmail"
            :disabled="disabledArr.includes('canEmail')"
          />
        </div>
        <div class="p-field p-col">
          <label for="canCall">can Call?</label>
          <InputSwitch
            v-model="contact.canCall"
            :disabled="disabledArr.includes('canCall')"
          />
        </div>
        <div class="p-field p-col">
          <label for="canMail">can Mail?</label>
          <InputSwitch
            v-model="contact.canMail"
            :disabled="disabledArr.includes('canMail')"
          />
        </div>
        <div class="p-field p-col">
          <label for="keyContact">Key Contact?</label>
          <InputSwitch
            v-model="contact.keyContact"
            :disabled="disabledArr.includes('keyContact')"
          />
        </div>
        <div class="p-field p-col">
          <label for="active">Active?</label>
          <InputSwitch
            v-model="contact.active"
            :disabled="disabledArr.includes('active')"
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="hideAndOpenCustomer"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="saveContact"
        />
      </template>
    </Dialog>

    <!-- Customer form -->
    <Dialog
      v-else-if="!contactFormDialog && customerFormDialog"
      :visible.sync="customerFormDialog"
      :style="{ width: '700px', overflowY: 'auto' }"
      header="Customer Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="custName">Customer Name *</label>
          <InputText
            id="custName"
            v-model.trim="customer.custName"
            required="true"
            :class="{ 'p-invalid': customerSubmitted && !customer.custName }"
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.custName"
            >Customer Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address1">House</label>
          <InputText
            id="address1"
            v-model.trim="customer.address1"
            :class="{ 'p-invalid': customerSubmitted && !customer.address1 }"
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address1"
            >Address1 is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address2">Street</label>
          <InputText
            id="address2"
            v-model.trim="customer.address2"
            :class="{ 'p-invalid': customerSubmitted && !customer.address2 }"
            required="false"
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address2"
            >Address2 is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address3">Sub Area</label>
          <InputText
            id="address3"
            v-model.trim="customer.address3"
            :class="{ 'p-invalid': customerSubmitted && !customer.address3 }"
            required="false"
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address3"
            >Address3 is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address4">City/Town</label>
          <CustomDropDown
            :allOptions="citiesTowns"
            :disabled="false"
            optionLabel="cityTownName"
            dataKey="id"
            :forceSelection="true"
            :showDropDownOnStart="true"
            :currentValue="cityTown1"
            placeholder="Select City/Town"
            style="width: 100%"
            @selected="setSelection1"
            :inputClass="{
              'p-invalid': customerSubmitted && !customer.cityTown
            }"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.cityTown"
            >City/Town is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="postCode">Post Code</label>
          <InputText
            id="postCode"
            v-model.trim="postCode"
            required="false"
            :class="{ 'p-invalid': customerSubmitted && !customer.postCode }"
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.postCode"
            >Post Code is required.</small
          >
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col" v-if="duplicateChecking">
          <div class="errorMsg" style="background-color: dodgerblue;">
            <span class="errorSpan">
              Checking for duplicate customers...
            </span>
          </div>
        </div>
        <div
          class="p-field p-col"
          v-if="!duplicateChecking && duplicates.length"
        >
          <div class="errorMsg">
            <span class="errorSpan pr-5">
              Possible duplicate customers: {{ duplicates.length }}
            </span>
            <span
              class="errorSpan errorPointer pr-3"
              @click="displayDuplicateMessage = true"
            >
              View duplicates
            </span>
            <span
              class="errorSpan errorPointer"
              @click="checkForDuplicate()"
              v-if="
                lastEnteredName !== customer.custName ||
                  lastEnteredAddress1 !== customer.address1 ||
                  lastEnteredAddress2 !== customer.address2 ||
                  lastEnteredAddress3 !== customer.address3 ||
                  lastEnteredCityTown !==
                    (customer.cityTown && customer.cityTown.id) ||
                  lastEnteredPostCode !== customer.postCode
              "
            >
              Check again
            </span>
          </div>
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="region">Region</label>
          <InputText
            v-if="customer.region"
            id="region"
            v-model.trim="customer.region.regionName"
            :disabled="true"
            required="false"
          />
          <InputText v-else id="region" :disabled="true" required="false" />
        </div>
        <div class="p-field p-col">
          <label for="branchName">Branch</label>
          <InputText
            id="branch"
            v-model.trim="branch.branchName"
            :disabled="true"
            required="false"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="salesExec">Sales Exec</label>
          <InputText
            id="salesExec"
            v-model.trim="salesExec.salesExecName"
            :disabled="true"
            required="false"
          />
        </div>
        <div class="p-field p-col">
          <label for="customerType">Customer Type</label>
          <Dropdown
            id="customerType"
            v-model="customerType"
            :options="customertypes"
            optionLabel="typeName"
            placeholder="Select Customer Type"
            :class="{
              'p-invalid': customerSubmitted && !customer.customerType
            }"
            :showClear="true"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.customerType"
            >Customer Type is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="phoneNo">Phone No</label>
          <InputText
            id="phoneNo"
            v-model.trim="customer.phoneNo"
            :class="{ 'p-invalid': customerSubmitted && !customer.phoneNo }"
            required="false"
          />
          <small class="p-invalid" v-if="customerSubmitted && !customer.phoneNo"
            >Phone number is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="mobile">Email</label>
          <InputText
            id="mobile"
            v-model.trim="customer.email"
            required="false"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="mainNotes">Notes</label>
          <InputText
            id="mainNotes"
            v-model.trim="customer.mainNotes"
            required="false"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="hideAndOpenCustomer"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="saveCustomer"
        />
      </template>
    </Dialog>

    <DuplicateDialog
      :key="duplicateDialogKey"
      :duplicateDialog="duplicateDialog"
      :contact="duplicateContact"
      :colSelectedFieldsForTable="colSelectedFieldsForTable"
      @hide-duplicate-dialog="duplicateDialog = false"
      @submit-duplicate-form="sendDuplicateContact"
    />

    <!-- Customer duplicate message -->
    <Dialog header="Header" :visible.sync="customerDuplicateMessage">
      <template #header>
        <h3>Duplicate error</h3>
      </template>

      The following Customer seems to be a duplicate of some customers. Please
      confirm if you wish to still save this customer?

      <template #footer>
        <Button
          @click="customerDuplicateMessage = false"
          label="No"
          icon="pi pi-times"
          class="p-button-text"
        />
        <Button
          @click="sendDuplicateCustomer()"
          label="Yes"
          icon="pi pi-check"
        />
      </template>
    </Dialog>

    <CustomerSearchDialog
      :key="loadCustomersAgain"
      :custSearchDialog="custSearchDialog"
      :preSelectedCustomer="preSelectedCustomer"
      :isContactRequired="true"
      @close="custSearchDialog = false"
      @select="updateCustomer"
      @selectContact="selectContactForm"
      @selectCustomer="selectCustomerForm"
    />

    <duplicateEnquiryTable
      v-if="colSelectedFieldsForTable"
      :duplicateDialog="displayEnquiryDuplicateMessage"
      :colSelectedFieldsForTable="colSelectedFieldsForTable"
      :dataId="'oppId'"
      :name="'Enquiry'"
      :namePlural="'Enquiries'"
      :list="duplicatEnquiries"
      :disabledArr="['buttons']"
      @close="displayEnquiryDuplicateMessage = false"
    />

    <duplicateTable
      v-if="displayDuplicateMessage"
      :duplicateDialog="displayDuplicateMessage"
      :dataId="'customerId'"
      :name="'Customer'"
      :namePlural="'Customers'"
      :list="duplicates"
      :disabledArr="['buttons']"
      :statuses="opportunityStatuses"
      @close="displayDuplicateMessage = false"
      @selected-customer="setCustomerSelection"
    />
  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService";
import CustomerService from "@/service/CustomerService";
import SettingService from "@/service/SettingService";

import CustomerSearchDialog from "../customer/CustomerSearchDialog";
import DuplicateDialog from "../contact/duplicateDialog";
import duplicateEnquiryTable from "./duplicateDialog";
import duplicateTable from "../customer/duplicateDialog";

import { mapActions, mapGetters } from "vuex";

import {
  opportunityRequest,
  contactRequest,
  customerLessDataRequest,
  customerConf
} from "../sendRequest";

export default {
  components: {
    CustomerSearchDialog,
    DuplicateDialog,
    duplicateEnquiryTable,
    duplicateTable
  },
  props: {
    opportunityDialog: {
      type: Boolean,
      required: true
    },
    opportunityToEdit: {
      type: Object,
      required: false
    },
    disabledArray: {
      type: Array,
      required: false
    },
    colSelectedFieldsForTable: {
      type: Array,
      required: false
    },
    onlyUserBranch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      settingService: new SettingService(),
      customerName: "",
      customernames: null,
      contacts: null,
      branches: [],
      regions: [],
      opportunityStatuses: [],
      projectTypes: null,
      custSearchDialog: false,
      quoteNo: 0,
      loading1: true,
      submitted: false,
      contactSubmitted: false,
      options: [true, false],
      disabledArr: [],
      custId: 0,
      opportunity: {},
      selectedCustomer: null,
      mbpBranch: null,
      phoneNo: "",
      duplicateInfo: {},
      salesExec1: {},
      salesExec1Name: "",
      region: {},
      opportunityStatus: {},
      customer: {},
      contact: {},
      // jobTitles: [],
      jobFunctions: [],
      contactFormDialog: false,
      preSelectedCustomer: {},
      duplicateDialogKey1: 0,
      duplicateDialog: false,
      duplicateToSend: {},
      duplicateContact: {},
      customerFormDialog: false,
      duplicateCustCode: null,
      customerType: {},
      customertypes: [],
      customerSubmitted: false,
      customerDuplicateMessage: false,
      loadCustomersAgain1: 0,
      postCode: "",
      branch: {},
      salesExec: {},
      sendingRequest: false,
      duplicatEnquiries: [],
      duplicateCheckingEnquiry: false,
      displayEnquiryDuplicateMessage: false,
      lastOppDescription: "",
      lastAddress1: "",
      lastAddress2: "",
      lastAddress3: "",
      lastCityTown: null,
      lastPostCode: "",
      citiesTowns: [],
      cityTown: {},
      reloadCustomDropdown1: 0,
      cityTown1: {},
      cityTown2: {},
      projectType: {},
      projectTypeKey1: 0,
      mbpBranchKey1: 0,

      duplicates: [],
      duplicateChecking: false,
      lastEnteredName: "",
      lastEnteredPostCode: "",
      lastEnteredAddress1: "",
      lastEnteredAddress2: "",
      lastEnteredAddress3: "",
      lastEnteredCityTown: "",
      displayDuplicateMessage: false
    };
  },
  computed: {
    projectTypeKey: {
      set() {
        this.projectTypeKey1++;
      },
      get() {
        return "projectTypeKey-" + this.projectTypeKey1.toString();
      }
    },
    mbpBranchKey: {
      set() {
        this.mbpBranchKey1++;
      },
      get() {
        return "mbpBranchKey-" + this.mbpBranchKey1.toString();
      }
    },
    reloadCustomDropdown: {
      set(val) {
        this.reloadCustomDropdown1++;
      },
      get() {
        return "reloadCustomDropdown" + this.reloadCustomDropdown1.toString();
      }
    },
    duplicateDialogKey: {
      set() {
        this.duplicateDialogKey1++;
      },
      get() {
        return "duplicateDialogKey-" + this.duplicateDialogKey1.toString();
      }
    },
    loadCustomersAgain: {
      set() {
        this.loadCustomersAgain1++;
      },
      get() {
        return "loadCustomersAgain-" + this.loadCustomersAgain1.toString();
      }
    },
    opportunityDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.opportunityDialog;
      }
    },
    ...mapGetters("auth", [
      "getMyProfile", // -> this.getMyProfile
      "getMyToken" // -> this.getMyToken
    ])
  },
  opportunityService: null,
  customerService: null,
  created() {
    this.opportunityService = new OpportunityService();
    this.customerService = new CustomerService();

    if (this.opportunityToEdit) {
      if (this.disabledArray) {
        this.disabledArr = this.disabledArray;
      } else {
        this.disabledArr = [
          "Description",
          "Address 1",
          "Address 2",
          "Address 3",
          "City/Town",
          "Post Code",
          "Country",
          "Customer"
        ];
      }
      this.opportunity = { ...this.opportunityToEdit };

      if (this.opportunityToEdit.opportunityStatus)
        this.opportunityStatus = this.opportunityToEdit.opportunityStatus;

      if (this.opportunityToEdit.contact) {
        this.contact = this.opportunityToEdit.contact;
        if (!this.opportunity.phoneNo)
          this.opportunity.phoneNo = this.contact.phoneNo;
        if (!this.opportunity.email)
          this.opportunity.email = this.contact.email;
      } else if (
        this.opportunityToEdit.contactId &&
        this.opportunityToEdit.contactName
      ) {
        this.contact = {
          contactId: this.opportunityToEdit.contactId,
          contactName: this.opportunityToEdit.contactName
        };
      }

      if (this.opportunity.salesExec) {
        this.salesExec1 = this.opportunity.salesExec;
      }

      if (this.opportunity.mbpBranch) {
        this.mbpBranch = {
          ...this.opportunity.mbpBranch,
          branchId: this.opportunity.mbpBranch.id
        };
      } else if (
        this.opportunityToEdit.mbpBranchId &&
        this.opportunityToEdit.mbpBranchName &&
        this.opportunityToEdit.mbpBranchCode
      ) {
        this.mbpBranch = {
          branchId: this.opportunityToEdit.mbpBranchId,
          branchName: this.opportunityToEdit.mbpBranchName,
          branchCode: this.opportunityToEdit.mbpBranchCode,
          salesExecId: this.opportunityToEdit.salesExecId,
          salesExecName: this.opportunityToEdit.salesExecName
        };
      }

      if (this.opportunity.phoneNo) {
        this.phoneNo = this.opportunity.phoneNo;
      }

      if (this.opportunityToEdit.region) {
        this.region = this.opportunityToEdit.region;
      } else if (
        this.opportunityToEdit.regionId &&
        this.opportunityToEdit.regionName
      ) {
        this.region = {
          id: this.opportunityToEdit.regionId,
          regionName: this.opportunityToEdit.regionName
        };
      }

      if (this.opportunityToEdit.cityTown) {
        this.cityTown = this.opportunityToEdit.cityTown;
      } else if (this.opportunityToEdit.cityTownId) {
        this.cityTown = {
          id: this.opportunityToEdit.cityTownId,
          cityTownName:
            this.opportunityToEdit.cityTownName ||
            this.opportunityToEdit.address4
        };
      }

      if (this.opportunityToEdit.projectType) {
        this.projectType = this.opportunityToEdit.projectType;
      } else if (
        this.opportunityToEdit.projTypeId &&
        this.opportunityToEdit.projTypeName
      ) {
        this.projectType = {
          id: this.opportunityToEdit.projTypeId,
          projTypeName: this.opportunityToEdit.projTypeName
        };
      }

      if (this.opportunityToEdit.customer) {
        this.selectedCustomer = this.opportunityToEdit.customer;
        this.customerName = this.opportunityToEdit.customer.custName;
      } else if (this.opportunityToEdit.customerId) {
        if (this.opportunityToEdit.custName) {
          this.customerName = this.opportunityToEdit.custName;
          this.selectedCustomer = {
            custName: this.opportunityToEdit.custName,
            customerId: this.opportunityToEdit.customerId
          };
        } else {
          this.selectedCustomer = {
            customerId: this.opportunityToEdit.customerId
          };
        }
      }

      if (this.selectedCustomer && this.selectedCustomer.customerId) {
        this.opportunity.customer = { ...this.selectedCustomer };

        this.customerService
          .getCustomerContacts(this.selectedCustomer.customerId)
          .then(data => (this.contacts = data))
          .catch(e => {
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer contacts",
            //   life: 5000,
            // })
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "customerContacts/{customerId}"'
            });
          });

        this.getEnquiryCustomerMBPbranches(this.selectedCustomer.customerId);
      }

      this.custSearchDialog = false;
    } else if (this.disabledArray) {
      this.disabledArr = this.disabledArray;
    }
  },
  destroyed() {},
  mounted() {
    try {
      if (document.getElementById("oppDescription"))
        document.getElementById("oppDescription").focus();
    } catch (e) {}

    this.customerService
      .getAllActiveRegions()
      .then(data => (this.regions = data))
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting regions",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeRegions"'
        });
      });
    this.opportunityService
      .getAllActiveOpportunityStatuses()
      .then(data => (this.opportunityStatuses = data))
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting Enquiry statuses",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeOpportunityStatuses"'
        });
      });
    this.opportunityService
      // .getAllProjectTypes()
      .getAllActiveProjectTypes()
      .then(data => (this.projectTypes = data))
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting enquiry types",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeProjectTypes"'
        });
      });
    this.loading1 = false;

    // this.customerService
    //   .getAllJobTitles()
    //   .then((data) => (this.jobTitles = data))
    //   .catch(err => {
    //

    //     // this.$toast.add({
    //     //   severity: "error",
    //     //   summary: "Error",
    //     //   detail: "Error while getting job titles",
    //     //   life: 5000,
    //     // })
    //     this.$store.dispatch('addErrorMessage', {
    //       severity: 'error',
    //       content: 'Some data was not loaded from "jobtitles"'
    //     })
    //   })
    this.customerService
      .getAllJobFunctions()
      .then(data => (this.jobFunctions = data))
      .catch(err => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting jobFunctions",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "jobFunctions"'
        });
      });
    this.customerService
      .getAllActiveCustomerTypes()
      .then(data => (this.customertypes = data))
      .catch(e => {
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting customer types",
        //   life: 5000,
        // })
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeCustomerTypes"'
        });
      });

    this.customerService
      .getAllActiveCitiesTowns()
      .then(data => (this.citiesTowns = data))
      .catch(error => {
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "citiesTowns"'
        });
      });
  },
  watch: {
    // onlyUserBranch(val) {
    //   if(val === true)
    //   this.mbpBranch = this.getMyProfile.defBranch
    //   else
    //   this.mbpBranch = {}
    // },
    projectTypes(val) {
      //
      this.projectTypeKey++;
    },
    projectType(val) {
      if (val && val.id) {
        this.opportunity.projectType = val;
        this.projectTypeKey++;
      }
    },
    postCode(val) {
      this.customer.postCode = val;

      this.customerService
        .getCustomerRegion(val)
        .then(res => {
          if (res[0] && res[0].id) {
            this.customer.region = {
              id: parseInt(res[0].regionCode),
              regionName: res[0].regionName
            };
            if (res[0].salesExec) {
              this.customer.salesExec = res[0].salesExec;
              this.salesExec = res[0].salesExec;
              this.salesExec1 = res[0].salesExec;
            }
            if (res[0].mbpBranch) {
              this.customer.mbpBranch = res[0].mbpBranch;
              this.branch = res[0].mbpBranch;
            }
          } else {
            throw new Error("Nothing found");
          }
        })
        .catch(err => {
          this.customer.region = {};
          this.branch = {};
          this.customer.mbpBranch = {};
          this.salesExec = {};
          this.customer.salesExec = {};
        });
    },
    customerType(val) {
      val && val.id
        ? (this.customer.customerType = val)
        : (this.customer.customerType = null);
    },
    duplicateDialog(val) {
      this.duplicateDialogKey++;
    },
    opportunityStatus(val) {
      this.opportunity.opportunityStatus = val;
    },
    opportunityStatuses(val) {
      if (val && val.length) {
        if (
          !(this.opportunityToEdit && this.opportunityToEdit.opportunityStatus)
        ) {
          this.opportunityStatus = val.find(a => a.oppStatusName === "New");
        }
      }
    },
    contact(val) {
      this.opportunity.contact = val;
      if (!this.opportunity.phoneNo) {
        this.opportunity.phoneNo = val.phoneNo;
      }
      if (!this.opportunity.email) {
        this.opportunity.email = val.email;
      }
    },
    branches(val) {
      this.mbpBranchKey++;
    },
    mbpBranch(val) {
      // In case of editing from EnquiriesTable
      if (val?.salesExecName) {
        this.salesExec1 = val;
        this.opportunity.mbpBranch = val;
      }
      // In case of editing from EnquiryDetail Page
      else if (val?.salesExec) {
        this.salesExec1 = val.salesExec;
        this.opportunity.mbpBranch = val;
      } // branch is set to None/Null/{}
      else {
        this.salesExec1 = {};
        this.opportunity.mbpBranch = null;
      }
      this.mbpBranchKey++;
    },
    phoneNo(val) {
      //
      this.opportunity.phoneNo = val;
    },
    salesExec1(val) {
      this.salesExec1Name = val.salesExecName;
      this.opportunity.salesExec = val;
    },
    cityTown(val) {
      if (val && val.id) {
        this.opportunity.cityTown = { ...val };
        this.reloadCustomDropdown = this.reloadCustomDropdown1 + 1;
      } else {
        this.opportunity.cityTown = null;
      }
    },
    cityTown1(val) {
      val && val.id
        ? (this.customer.cityTown = val)
        : (this.customer.cityTown = null);
    },
    cityTown2(val) {
      val && val.id
        ? (this.contact.cityTown = val)
        : (this.contact.cityTown = null);
    },
    region(val) {
      if (val && val.id) {
        //
        this.opportunity.region = { ...val };
      } else {
        this.opportunity.region = null;
      }
    }
  },
  methods: {
    setCustomerSelection(customer) {
      this.displayDuplicateMessage = false;

      this.contactFormDialog = false;
      this.customerFormDialog = false;
      this.custSearchDialog = true;
      this.loadCustomersAgain++;
      this.preSelectedCustomer = customer;
      this.customer = {};
    },
    checkForDuplicate() {
      if (
        this.customer &&
        this.customer.custName &&
          this.customer.address1 &&
          this.customer.address2 &&
          this.customer.address3 &&
          this.customer.cityTown &&
          this.customer.cityTown.id &&
          this.customer.postCode &&
        (this.lastEnteredName !== this.customer.custName ||
          this.lastEnteredAddress1 !== this.customer.address1 ||
          this.lastEnteredAddress2 !== this.customer.address2 ||
          this.lastEnteredAddress3 !== this.customer.address3 ||
          this.lastEnteredCityTown !== this.customer.cityTown.id ||
          this.lastEnteredPostCode !== this.customer.postCode)
      ) {
        //

        this.lastEnteredName = this.customer.custName;
        this.lastEnteredAddress1 = this.customer.address1;
        this.lastEnteredAddress2 = this.customer.address2;
        this.lastEnteredAddress3 = this.customer.address3;
        this.lastEnteredCityTown = this.customer.cityTown.id;
        this.lastEnteredPostCode = this.customer.postCode;

        this.duplicateChecking = true;
        this.customerService
          .getDupCustomers({
            custName: this.customer.custName,
            address1: this.customer.address1,
            address2: this.customer.address2,
            address3: this.customer.address3,
            cityTown: this.customer.cityTown.id,
            postCode: this.customer.postCode,
            address4: ""
          })
          .then(data => {
            this.duplicateChecking = false;
            //
          })
          .catch(error => {
            //
            this.duplicateChecking = false;
            this.duplicates = [];

            if (error && error.response && error.response.status === 409) {
              this.duplicates = error.response.data;
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while checking for duplicate enquiries.",
                life: 5000
              });
            }
          });
      }
    },
    checkForDuplicateEnquiry() {
      if (
        this.opportunity &&
        this.opportunity.oppDescription &&
          this.opportunity.address1 &&
          this.opportunity.address2 &&
          this.opportunity.address3 &&
          this.opportunity.cityTown &&
          this.opportunity.cityTown.id &&
          this.opportunity.postCode &&
        (this.lastOppDescription !== this.opportunity.oppDescription ||
          this.lastAddress1 !== this.opportunity.address1 ||
          this.lastAddress2 !== this.opportunity.address2 ||
          this.lastAddress3 !== this.opportunity.address3 ||
          this.lastCityTown !== this.opportunity.cityTown.id ||
          this.lastPostCode !== this.opportunity.postCode)
      ) {
        //

        this.lastOppDescription = this.opportunity.oppDescription;
        this.lastAddress1 = this.opportunity.address1;
        this.lastAddress2 = this.opportunity.address2;
        this.lastAddress3 = this.opportunity.address3;
        this.lastCityTown = this.opportunity.cityTown.id;
        this.lastPostCode = this.opportunity.postCode;

        this.duplicateCheckingEnquiry = true;
        this.opportunityService
          .getDupEnquiry({
            oppDescription: this.opportunity.oppDescription,
            address1: this.opportunity.address1,
            address2: this.opportunity.address2,
            address3: this.opportunity.address3,
            cityTown: this.opportunity.cityTown.id,
            postCode: this.opportunity.postCode,
            address4: ""
          })
          .then(data => {
            this.duplicateCheckingEnquiry = false;
            //
          })
          .catch(error => {
            //
            this.duplicateCheckingEnquiry = false;
            this.duplicatEnquiries = [];

            if (error && error.response && error.response.status === 409) {
              this.duplicatEnquiries = error.response.data;
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while checking for duplicate enquiries.",
                life: 5000
              });
            }
          });
      }
    },
    sendDuplicateCustomer() {
      customerConf(this, "OpportunityForm.vue");
    },
    sendDuplicateContact() {
      this.duplicateDialog = false;

      this.duplicateToSend.customer = this.preSelectedCustomer.customerId;

      this.customerService
        .saveDuplicateContactDB(this.duplicateToSend)
        .then(response => {
          this.contactFormDialog = false;
          this.customerFormDialog = false;
          this.custSearchDialog = true;

          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Contact Saved",
              detail: `New contact was saved successfully`,
              life: 5000
            });
          }
        })
        .catch(err => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while saving contact",
            life: 5000
          });
        });
    },
    selectCustomerForm() {
      this.customer = {};
      this.postCode = "";
      this.region = {};
      this.cityTown = {};
      this.branch = {};
      this.salesExec = {};
      this.customerType = {};
      this.cityTown1 = {};
      this.customerSubmitted = false;
      this.custSearchDialog = false;
      this.contactFormDialog = false;
      this.customerFormDialog = true;

      try {
        setTimeout(() => {
          let a = document.getElementById("custName");
          if (a) a.focus();
        }, 100);
      } catch (e) {}
    },
    selectContactForm({ customer, contactToEdit }) {
      this.preSelectedCustomer = customer;
      this.customer = customer;

      if (contactToEdit) {
        this.contact = { ...contactToEdit };

        if (contactToEdit.customerId) {
          this.customerService
            .getCustomerInfo(contactToEdit.customerId)
            .then(data => {
              this.contact.customer = data;
              this.customerName = data.custName;
              this.cityTown2 = data.cityTown;
              this.contact.address1 = data.address1;
              this.contact.address2 = data.address2;
              this.contact.address3 = data.address3;
              this.contact.address4 = data.address4;
            })
            .catch(err => {
              // this.$toast.add({
              //   severity: "error",
              //   summary: "Error",
              //   detail: "Error while geting customer info",
              //   life: 5000,
              // })
              this.$store.dispatch("addErrorMessage", {
                severity: "error",
                content:
                  'Some data was not loaded from "customerInfo/{customerId}"'
              });
            });
        }
        if (
          contactToEdit.fullName &&
          !(contactToEdit.firstName && contactToEdit.lastName)
        ) {
          this.contact.firstName = contactToEdit.fullName.split(" ")[0] || "";
          this.contact.lastName = contactToEdit.fullName.split(" ")[1] || "";
        }
      }

      this.custSearchDialog = false;
      this.customerFormDialog = false;
      this.contactFormDialog = true;

      try {
        setTimeout(() => {
          let a = document.getElementById("firstName");
          if (a) a.focus();
        }, 100);
      } catch (e) {}
    },
    saveCustomer() {
      this.customerSubmitted = true;

      if (!this.duplicateCustCode) {
        this.sendingRequest = true;
        customerLessDataRequest(this, "OpportunityForm.vue");
      }
    },
    saveContact() {
      this.contactSubmitted = true;
      this.sendingRequest = true;

      this.contact.customer = this.customer;
      //
      contactRequest(this, "OpportunityForm.vue");
    },
    hideAndOpenCustomer() {
      this.preSelectedCustomer = {};
      this.contactFormDialog = false;
      this.customerFormDialog = false;
      this.custSearchDialog = true;
    },
    getEnquiryCustomerMBPbranches(customerId) {
      this.customerService
        .getEnquiryCustomerMBPbranches(customerId)
        .then(data => {
          this.branches = data;
          if (this.onlyUserBranch === true && this.getMyProfile.defBranch) {
            let branch = this.branches.filter(
              b => b.branchId == this.getMyProfile.defBranch.id
            );
            if (branch.length === 1) {
              this.mbpBranch = branch[0];
            } else {
              this.mbpBranch = null;
            }
          }
        })
        .catch(e => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "getEnquiryCustomerMBPbranches/{customerId}"'
          });
        });
    },
    // updateStatus(val) {
    //
    //   // if (this.opportunity && this.opportunity.oppId && val.id) {
    //   this.opportunityStatus = val
    //   this.$refs.statuses.toggle(event);
    //   // }
    // },
    // changeStatus() {
    //   this.$refs.statuses.toggle(event);
    // },
    getStyle(data) {
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data && data.colourCode) {
        return data.colourCode;
      } else if (
        data &&
        data.oppStatusName &&
        data.oppStatusName.toLowerCase() === "lost"
      ) {
        return "badge-danger";
      } else if (
        data &&
        data.oppStatusName &&
        data.oppStatusName.toLowerCase() === "otp"
      ) {
        return "badge-info";
      } else if (
        data &&
        data.oppStatusName &&
        data.oppStatusName.toLowerCase() === "cancelled"
      ) {
        return "badge-light";
      } else if (
        data &&
        data.oppStatusName &&
        data.oppStatusName.toLowerCase() === "won"
      ) {
        return "badge-success";
      } else if (
        data &&
        data.oppStatusName &&
        data.oppStatusName.toLowerCase() === "tender"
      ) {
        return "badge-warning";
      } else {
        return "badge-dark";
      }
    },
    updateCustomer(e) {
      if (e.customer) {
        this.selectedCustomer = e.customer;
        this.contact = e.contact;
        this.custId = e.customer.customerId;
        this.region = {};

        this.customerService
          .getCustomerInfo(e.customer.customerId)
          .then(data => {
            //
            this.selectedCustomer = data;
            // this.salesExec1 = data.salesExec
            this.region = data.region;
            if (!this.cityTown) {
              this.cityTown = data.cityTown;
            }
          })
          .catch(e => {
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer info",
            //   life: 5000,
            // })
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "customerInfo/{customerId}"'
            });
          });

        this.loadData(e);
      }
    },
    loadData({ customer, contact, contacts }) {
      if (this.opportunity) {
        this.contacts = contacts;

        this.opportunity.customer = { ...this.selectedCustomer };
        if (customer.custName)
          this.customerName = this.selectedCustomer.custName;
        if (customer.mbpBranch) {
          this.opportunity.mbpBranch = this.selectedCustomer.mbpBranch;
          this.mbpBranch = this.selectedCustomer.mbpBranch;
        }
        if (contact) {
          this.opportunity.contact = contact;
          this.phoneNo = contact.phoneNo;
          this.opportunity.email = contact.email;
        }

        this.getEnquiryCustomerMBPbranches(customer.customerId);

        this.custSearchDialog = false;
      }
    },
    save() {
      this.sendingRequest = true;

      this.submitted = true;
      if (this.opportunity) {
        opportunityRequest(this, this.opportunity, "OpportunityForm.vue");
      } else {
        this.sendingRequest = false;
        this.$toast.add({
          severity: "warn",
          summary: "Enquiry info not found",
          life: 5000
        });
      }
    },
    setSelection({ value, index }) {
      this.cityTown = value;
      this.checkForDuplicateEnquiry();
    },
    setSelection1({ value, index }) {
      this.cityTown1 = value;
      this.checkForDuplicate();
    },
    setSelection2({ value, index }) {
      this.cityTown2 = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: auto;
  font-size: 16px;
}

.search-button {
  position: absolute;
  top: 25px;
  right: 7px;
}
</style>
